import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";

import MDTypography from "common/components/MD/MDTypography";


// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";

//prop-types is a library for typechecking of props
// Data


import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import AuthService from "services/API/Auth/AuthService";

import { useFarFieraUIController } from "common/context/FarFieraContext";
import InvitiCard from "./InvitiCard";

import InvitiList from "./InvitiList";
import InvitiEditModal from "./InvitiEditModal";
import { useForm } from "react-hook-form";
import InvitiService from "services/API/Inviti/InvitiService";
import PropTypes from "prop-types";
import { Alert } from "@mui/material";


import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

function InvitiVis({ tipo = "IR" }) {


  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione } = ffcontroller;
  const [part, setPart] = useState({ idPartecipazione: 0, dotazioni: [{ id_dotazione: 0, tipo_dotazione: '' }], richieste: [{ idRichiesta: 0, num_ir_assegnati: 10000, num_io_assegnati: 100000 }] });
  const location = useLocation();
  const [submitted, setSubmitted] = useState(true);

  let color = (tipo === "IO" ? "primary" : (tipo === "IR" ? "info" : (tipo === "PE" ? "warning" : "success")));
  let title = (tipo === "IO" ? "I miei Biglietti Omaggio per " + manifestazione : (tipo === "IR" ? "I miei Biglietti Ridotti per " + manifestazione : (tipo === "PE" ? "I miei Pass Espositore per " + manifestazione : "")));


  useEffect(() => {
    filtra();


  }, [location.pathname]);


  function filtra() {
    /* if (AuthService.isExpo()) {
          console.log("ESPOSITORE");
          seleziona_soggetto();
        }
        if (AuthService.isAdmin()) {
          console.log("ADMIN");
          setPart({
            idPartecipazione: 0,
            richieste: [{ idRichiesta: 0, num_io: 1000, num_ir: 1000, num_pe: 1000, num_ir_assegnati: 0, num_io_assegnati: 0, num_pe_assegnati: 0 }]
          });
    
        }*/
    seleziona_soggetto();

  }

  async function seleziona_soggetto() {

    const response = await ExpoPartecipazioniService.seleziona_partecipazione(manifestazione);
    console.log(response);
    if (response) {
      if (response.errors) {
        console.log("ERRORE:::");
        console.log(response.errors);
        setPart(null);
      } else {
        retrive(response.data);
      }
    } else {
      console.log("ERRORE:::");
      setPart(null);
    }
  }



  function retrive(data) {
    console.log("RETRIVE");
    console.log(data);
    setPart({
      idPartecipazione: data.idPartecipazione,
      id_utente: data.id_utente,
      richieste: data.richieste,
    });

  }


  ////////////////////////////////////////////////////////////////////////
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const aggiungi_invito = () => {
  prima_di_filtrare();
    handleShow2();

  }


  /* ----------------------------SALVATAGGIO E REGISTRAZIONE------------------------------------------------- */

  const {
    register, //register inputs
    reset, setValue, control,
    handleSubmit,//handle form submit
    formState: { errors }
  } = useForm({
  });




  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);


  function handleResponse(response, operazione) {
    setError(null);
    console.log("filtra2:"+operazione);
    filtra2();
  }

  function prima_di_filtrare(){
    setSubmitted(false);

  }

  function filtra2() {
    filtra();
    setSubmitted(true);
    handleClose2();

  }
  const salva_invito = (formData) => {
    if (AuthService.isTokenOk()) {
      console.log("SALVO INVITI " + formData.num);
      setError(null);

      const datalist = [];

      for (let i = 0; i < formData.num; i++) {

        var data = {
          idInvito: 0,
          id_richiesta: formData.id_richiesta,
          nome: formData.nome,
          cognome: formData.cognome,
          azienda: formData.azienda,
          email: formData.email, tipo_dot: formData.tipo_dot
        }
        datalist.push(data);
      }
      InvitiService.aggiungi_inviti(datalist)
        .then(response => {
          handleResponse(response, "INS");
        })
        .catch(errore => {
          handleError(errore);
        });

    }
  };

  const elimina_invito = (idInvito) => {

    console.log("ELIMINO INVITO " + idInvito);
    setSubmitted(false);
    setError(null);

    InvitiService.elimina_invito(idInvito)
      .then(response => {
        handleResponse(response, "DEL");
      })
      .catch(errore => {
        handleError(errore);
      });

  }



  const invia_invito = (idInvito) => {

    console.log("INVIO INVITO " + idInvito);
    setSubmitted(false);
    setError(null);

    InvitiService.invia_invito(idInvito)
      .then(response => {
        handleResponse(response, "SEND");
      })
      .catch(errore => {
        handleError(errore);
      });

  }



  const stampa_invito = (idInvito) => {

    console.log("STAMPA INVITO " + idInvito);

prima_di_filtrare();
    let filename = 'InvitoAgriumbria2026.pdf';

    if(tipo==="PE"){
      filename="PassEspositore.pdf"
    }

     InvitiService.stampa_invito(idInvito)
    .then(response => {

      const blobBase64 = response.data;

      const arrayBuffer = base64ToArrayBuffer(blobBase64);
      const pdfBlob = new Blob([arrayBuffer], { type: "application/pdf" });
      const url = URL.createObjectURL(pdfBlob);

      const a = document.createElement('a');
      a.href = url;
      a.target = "_blank";
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();

      handleResponse(response, "PRINT");   

    })
    .catch(error => {
      console.error(error);
      handleError(error);
    });


  }

  function handleError(error) {
    setError(error);
    console.log("ERRORE" + error);
    console.log(error.code);

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log("ERROR:RESPONSE" + error.response.data);
      console.log(error.response.data);
      setErrorMessage(error.response.data);


    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log("EEROR:REQUEST" + error.request);
      setErrorMessage(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
      setErrorMessage(error.message);
    }

    handleClose2();
     filtra2();

  }


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>

          <Grid item xs={12}>
            {(part && (part.idPartecipazione || AuthService.isAdmin())) &&

              <Card>
                <HeaderForm bgColor={color} titolo={title} />
                {Array.isArray(part.richieste) && part.richieste.map((richiesta) => (
                  <MDBox key={richiesta.idRichiesta}>
                    <Grid container spacing={3} mt={10} ml={10}>
                      <Grid item xs={12} md={6} lg={4}>
                        <MDBox mb={1.5}>

                          <InvitiCard

                            num={tipo === "IO" ? richiesta.num_io : (tipo === "IR" ? richiesta.num_ir : (tipo === "PE" ? richiesta.num_pe : 0))}
                            num_disponibili={tipo === "IO" ? richiesta.num_io_disponibili : (tipo === "IR" ? richiesta.num_ir_disponibili : (tipo === "PE" ? richiesta.num_pe_disponibili : 0))}
                            id_richiesta={richiesta.idRichiesta}
                            aggiungi_invito={aggiungi_invito}



                            tipo={tipo}
                            percentage={{
                              color: tipo === "IR" ? "info" : "primary",
                              amount: tipo === "IR" ? richiesta.num_ir_assegnati : richiesta.num_io_assegnati,
                              label: "da assegnare"
                            }}

                          />
                        </MDBox></Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <MDBox mb={1.5}>

                        </MDBox></Grid>
                    </Grid>
                            {error !== null &&
                <Alert color="error"><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{errorMessage}</Alert>
              }

                    <InvitiList idRichiesta={richiesta.idRichiesta} tipo={tipo} key={`${richiesta.idRichiesta}-${tipo}-${submitted}`}
                      refresh={submitted} elimina_invito={elimina_invito} invia_invito={invia_invito} filtra={filtra2} prima_di_filtrare={prima_di_filtrare}
                      stampa_invito={stampa_invito} />
                    <InvitiEditModal
                      onSave={salva_invito}
                      tipo_dot={tipo}
                      id_richiesta={richiesta.idRichiesta}
                      num_max={tipo === "IO" ? richiesta.num_io_disponibili : (tipo === "IR" ? richiesta.num_ir_disponibili : (tipo === "PE" ? richiesta.num_pe_disponibili : 0))}
                      onClose={handleClose2}
                      show={show2}
                      part={part}
                    />
                  </MDBox>
                ))}


              </Card>




            }

            {(!part.idPartecipazione && !AuthService.isAdmin()) &&

              <Card>
                <HeaderForm bgColor={tipo === "IR" ? "info" : "primary"} titolo={tipo === "IR" ? "I miei inviti Ridotti ad " + manifestazione : "I miei inviti Omaggio ad " + manifestazione} />


                <MDBox style={{ height: "200px" }} textAlign='center'>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    Non sei abilitato ad accedere a questa area!
                  </MDTypography></MDBox>
              </Card>
            }
          </Grid>
        </Grid>
      </MDBox>








      <Footer />
    </DashboardLayout>
  );
}

InvitiVis.defaultProps = {

  tipo: "IR",
};


// Typechecking props for the Footer
InvitiVis.propTypes = {
  tipo: PropTypes.string,

};

export default InvitiVis;
